import type { StatusCheck } from "@eulerxyz/evc-sdk"
import {
  type Address,
  BaseError,
  type ContractFunctionRevertedError,
} from "viem"
import type { TransactionItems } from "../factories"

interface AddressMappedContractError {
  [address: Address]: ContractFunctionRevertedError
}

export class SimulateError extends BaseError {
  transactions: TransactionItems
  accountStatusErrors?: AddressMappedContractError
  vaultStatusErrors?: AddressMappedContractError

  constructor(
    transactions: TransactionItems,
    accountStatusErrors: StatusCheck[],
    vaultStatusErrors: StatusCheck[],
  ) {
    super("Errors occurred while simulating EVC batch call.")

    this.transactions = transactions
    this.accountStatusErrors = this.#reduceStatusErrors(accountStatusErrors)
    this.vaultStatusErrors = this.#reduceStatusErrors(vaultStatusErrors)
  }

  #reduceStatusErrors = (statusErrors: StatusCheck[]) =>
    statusErrors.reduce<AddressMappedContractError>((acc, cur) => {
      if (cur.status === "failure") {
        acc[cur.checkedAddress] = cur.error
      }
      return acc
    }, {})
}
